import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RecurringDonationModel } from '@app/core/Models';
import { environment } from '@environments/environment';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { CommonService } from '../..';

@Injectable({
  providedIn: 'root',
})
export class RecurringDonationService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  createRecurringDonation(
    recurringRecurringDonation: RecurringDonationModel
  ): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(
      `${environment.apiVersionUrl}RecurringDonation/save`,
      this.commonService.trimObjectSpace(
        JSON.stringify(recurringRecurringDonation)
      ),
      headers
    );
  }

  getDataByRecurringDonationId(
    recurringRecurringDonationId: Guid
  ): Observable<RecurringDonationModel> {
    return this.http.get<RecurringDonationModel>(
      `${environment.apiVersionUrl}RecurringDonation/get/${recurringRecurringDonationId}`
    );
  }

  deleteRecurringDonation(
    recurringRecurringDonationIds?: Array<Guid>
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: this.commonService.trimObjectSpace(
        JSON.stringify(recurringRecurringDonationIds)
      ),
    };
    return this.http.delete<any>(
      `${environment.apiVersionUrl}RecurringDonation/delete`,
      options
    );
  }

  copyRecurringDonation(
    recurringRecurringDonationIds?: Array<Guid>
  ): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.put<any>(
      `${environment.apiVersionUrl}RecurringDonation/copyRecurringDonation`,
      this.commonService.trimObjectSpace(
        JSON.stringify(recurringRecurringDonationIds)
      ),
      headers
    );
  }

  archiveAndRestoreRecurringDonation(
    recurringRecurringDonationIds?: Array<Guid>,
    isArchive?: boolean
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.patch<any>(
      `${environment.apiVersionUrl}RecurringDonation/archive/${isArchive}`,
      this.commonService.trimObjectSpace(
        JSON.stringify(recurringRecurringDonationIds)
      ),
      options
    );
  }
}
